import { Fragment, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Modal, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import TextArea from "antd/lib/input/TextArea"
import { baseAxiosComplete } from "../../../tool/axios"
import { SelectStores } from "../../../component/common/Selects"
import _ from 'lodash'

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 }
}

interface Prop {
    storeID?: string
    onChange: () => void

    checkInRecordData?: checkInRecordData[],
    serviceData?: any
}

interface checkInRecordData {
    room_type_name: string,
    room_number: string,
    check_in_day_range: string
}

interface ep {
    "employee_id": string,
    "user_name": string
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const onFinish = (values: any) => {
        baseAxiosComplete.post('/keeper/check_in/across_store/add', {
            check_in_id: param.id,
            roll_out_date: form.getFieldValue('roll_out_date') ? form.getFieldValue('roll_out_date').format('YYYY-MM-DD') : null,
            shift_in_store_id: form.getFieldValue('shift_in_store_id'),
            remark: form.getFieldValue('remark')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 跨店转房 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>跨店转房</Button>

        <Modal title="跨店转房" width={450} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <p style={{ fontWeight: 'bold', fontSize: 16 }}>带红色<span style={{ color: 'red' }}>*</span>号的表单项为必填项！</p>

                <Form {...formItemLayout} form={form} style={{ marginTop: 15 }} >
                    <Form.Item label="转出日期" name="roll_out_date" required>
                        <DatePicker />
                    </Form.Item>

                    <Form.Item label="转入门店" name="shift_in_store_id" required>
                        <SelectStores />
                    </Form.Item>

                    <Form.Item label="备注" name="remark" >
                        <TextArea style={{ height: 150, width: 200 }} />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}